<<template>
  <div class="ui-content dashboard">
    <div class="create-new-test">
      <div class="text-center">
        <v-btn
          v-if="user && user.role_code == 'ST'"
          class="right-btn cust-btn"
          color="primary"
          @click="gotoPracticeSessions()"
        >
          New Practice Sessions
        </v-btn>
      </div>
    </div>
    <v-card class="mx-auto normal-card autohg indcard">
      <div class="data-table-section small-desktop" ref="infoBox">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
            <!-- <div class="test-name-search">
              <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearchTest()"
                  solo
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
              </div>
            </div> -->
          </template>

          <template v-slot:body="{ items }">
            <tbody class="inst-data-body">
              <tr v-for="item in items" :key="item.name">
                <td
                  class="int-1201 text-center"
                  @click="gotoDetailedAnalysis(item)"
                >
                  {{ startDate(item.date) }}
                </td>
                <td class="int-120-t text-center">
                  {{
                    parseInt(item.timeSpent / 60) + "." + (item.timeSpent % 60)
                  }}
                </td>
                <td class="duration-display text-center">
                  {{ item.subjet }}
                </td>
                <td
                  class="duration-display green-font text-center"
                  v-if="item.healthImpact >= 0"
                >
                  + {{ item.healthImpact.toFixed(2) || 0 }} %
                  <img src="../../../../../src/assets/img/UpArrowGreen.svg" />
                </td>
                <td
                  class="duration-display red-font text-center"
                  v-else-if="item.healthImpact <= 0"
                >
                  {{ item.healthImpact.toFixed(2) || 0 }} %
                  <img src="../../../../../src/assets/img/DownArrowRed.svg" />
                </td>
                <td class="text-center max-220-width">
                  <v-tooltip
                    bottom
                    content-class="cust-new-tooltip-top"
                    :open-on-click="true"
                    :open-on-hover="false"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="ellipsis-txt" v-on="on">
                        {{
                          item.chapter.length < 20
                            ? item.chapter
                            : item.chapter.substring(0, 25) + "..."
                        }}
                      </div>
                    </template>
                    <span
                      v-html="item.chapter"
                      class="text-center tool-tip-position"
                    >
                    </span>
                  </v-tooltip>
                </td>
                <td class="text-center download-icon">
                  <v-img class="loader-img" src="../../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                    ></v-img>
                  <v-btn
                    v-else-if="user.institute === constants.ONLINE_INSTITUTE_ID && !hasMasterPyqModule"
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click="downloadPracticeReport(item)"
                  >
                    <v-icon small color="grey">mdi-lock</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click="downloadPracticeReport(item)"
                  >
                    <v-img
                      width="23px"
                      src="../../../../assets/img/download.svg"
                    ></v-img>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
import { showUpgradeModal } from "@/utils/upgradeUtils.js";

export default {
  name: "ImprovementAssignmentsTestsList",
  async mounted() {
    this.options = this.qTypes.map((x) => {
      let c = {};
      c.text = x.title;
      c.value = x.value;
      return c;
    });
    this.headers = [
      {
        text: "Date",
        class: "text-center",
        value: "start_time",
      },
      {
        text: "Duration (mins)",
        class: "text-center",
        value: "duration",
      },
      {
        text: "Subject",
        value: "subject",
        class: "text-center",
        type: "multidropdown",
        options: [],
        allText: "All Subject",
      },
      {
        text: "Subject Health Impact",
        value: "impact_subject_health",
        class: "text-center",
        hideSort: true,
      },
      {
        text: "Chapter Covered",
        value: "chapter.title",
        class: "text-center",
        hideSort: true,
      },
      {
        text: "Download Report",
        value: "download_report",
        class: "text-center",
        hideSort: true,
      },
    ];
    if (!(this.user && this.user.subscription_details)) {
      await this.delayTime(1000);
    }
    localStorage.removeItem("prevPath");
    localStorage.setItem("prevPath", this.$route.name);
    this.checkStudentUpgraded();

    if (this.user.role_id == this.roleIds.PA) {
      this.initStudentData();
    } else {
      this.studentId = this.user.id;
      this.batchId = this.user.batch_id;
      this.checkSessionData();
    }
    this.downloadStatus = constants.DOWNLOAD_STATUS;
    this.checkMasterPyqModule();
  },
  computed: {
    ...mapState("userStore", ["user"]),
    constants() {
      return constants;
    }
  },
  watch: {
    selectedExamTypes(val) {
      if (val) {
        this.requestGetTestList();
      }
    },
  },
  data() {
    return {
      headers: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      selectedExamTypes: [],
      qTypes: constants.TEST_TYPES_IT,
      alertBoxData: {},
      status: false,
      cComponent:
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
      modalwidth: "500px",
      selectedStudent: {},
      studentId: 0,
      batchId: 0,
      downloadStatus: {},
      requestIds: [],
      testStatusTimeout: 0,
      toasts:{},
      hasMasterPyqModule: false
    };
  },
  methods: {
    ...mapActions({
      getPracticeSessionList: "testStore/getPracticeSessionList",
      getSubjectBatchWise: "resultStore/getSubjectBatchWise",

      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
    }),
    checkMasterPyqModule() {
      const userDetails = this.user || JSON.parse(localStorage.getItem('user') || '{}');

      if (userDetails?.institute === constants.ONLINE_INSTITUTE_ID) {
        const subscriptionDetails = userDetails.subscription_details || [];

        const MASTER_PYQ_IDS = [
          constants.MODULES.MASTERPYQJEE26,
          constants.MODULES.MASTERPYQJEE27,
          constants.MODULES.MASTERPYQNEET26,
          constants.MODULES.MASTERPYQNEET27
        ].map(Number);

        const masterPyqSub = subscriptionDetails.find(
          sub => sub.name === "MASTERPYQPREMIUM"
        );

        this.hasMasterPyqModule = Boolean(
          masterPyqSub &&
          Array.isArray(masterPyqSub.product_id) &&
          masterPyqSub.product_id
            .map(Number)          
            .some(id => MASTER_PYQ_IDS.includes(id))
        );
      } else {
        const moduleDetails = JSON.parse(localStorage.getItem('modules') || '[]');
        this.hasMasterPyqModule = moduleDetails.some(
          mod => mod.module_id === constants.MODULES.BOOSTUP
        );
      }
    },
    clearStuckLoadingStates() {
      // Clear any stuck loading states from previous sessions
      this.items = this.items.map(item => {
        if (item.status === constants.DOWNLOAD_STATUS.IN_PROGRESS) {
          item.status = null;
          item.request_id = null;
        }
        return item;
      });
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.requestIds = crd.tabDetails[crd.selectedTab].requestIds || []; // load center ids from session
        // this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetTestList();
      this.getSubjects();
      this.checkDownloadUpdate()
    },

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "requestIds":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.requestIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    startDate(startDate) {
      return startDate ? moment(startDate).format("DD/MM/YYYY") : "";
    },
    gotoPracticeSessions() {
      this.$router.push({
        name: "practice-session",
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err);
        }
      });
    },
    requestGetTestList() {
      // if (!this.checkStudentUpgraded()) {
        this.$root.showLoader = true;
        let reqData = {
          student_id: this.studentId,
          sortBy: {
            order: this.orderBy.order,
            field: this.orderBy.field,
          },
          pagination: {
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        };
        if (this.subject_ids && this.subject_ids.length) {
          reqData.subject_ids = this.subject_ids;
        }
        this.getPracticeSessionList(reqData)
          .then((response) => {
            if (
              response.list.length == 0 &&
              this.currentPage != 1 &&
              !this.$route.query.resetPage
            ) {
              this.onPageChange(1);
              return;
            }
            this.$root.showLoader = false;
            this.items = response.list;
            this.totalPages = response.pagination.pageCount;
            this.clearStuckLoadingStates();
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      // } else return;
    },

    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onHeaderAction(e) {
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        e.header.value === "subject"
      ) {
        this.subject_ids = e.data.selectedItems;
        this.requestGetTestList();
      }
    },
    onClose(data) {
      this.status = data.status;
      
      // Handle upgrade confirmation modal response
      if (data.openPaymentModal) {
        this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
        this.modalwidth = '500px';
        this.status = true;
        this.alertBoxData = data.paymentData;
        return;
      }
      
      // Handle payment success - refresh Master PYQ module status
      if (data.paymentSuccess) {
        // Refresh user data and check Master PYQ module again
        this.checkMasterPyqModule();
        this.$toasted.success('Payment successful! You now have access to download reports.', { icon: 'check_circle' });
        return;
      }
      
      if (data && data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
    },
    redirectTo(route) {
      this.$router.push({
        name: route,
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err);
        }
      });
    },
    gotoDetailedAnalysis(item) {
      if (!this.checkStudentUpgraded()) {
        let batch_id = this.user.batch_id;
        let student_test_id = item.student_test_id;
        let test_institute_id = item.test_institute_id;
        let test_name = item.test_name;
        let test_id = item.test_id;
        let hide = true;
        let routeName = "response-analysis-practice";
        this.$router.push({
          name: routeName,
          params: {
            test_name,
            student_test_id,
            test_institute_id,
            test_id,
            batch_id: this.batchId,
            student_id: this.studentId,
            hide,
          },
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    },

    getSubjects() {
      let reqData = {
        student_id: this.studentId,
        batch_id: this.batchId,
      };
      // if (this.isParent) {
      // 	reqData.student_id = this.studentId;
      // 	reqData.batch_id = this.selectedStudent.batchId;
      // }
      let me = this;
      this.getSubjectBatchWise(reqData)
        .then((response) => {
          this.headers[2].options = response.map((s) => {
            return {
              text: s.title,
              value: s.id,
              selected: false,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadPracticeReport(item) {
      // Check if user has Master PYQ access for online institute
      if (this.user.institute === constants.ONLINE_INSTITUTE_ID && !this.hasMasterPyqModule) {
        showUpgradeModal(this);
        return;
      }
      
      if (this.status) {
        showUpgradeModal(this);
        return;
      }
      let domainUrl = process.env.VUE_APP_API_URL;
      let token = sessionStorage.getItem("auth_token");
      let url = `test/download-practice-report/${item.test_id}?token=${token}`;

      this.downloadTestResource(url, item);
    },
    downloadTestResource(url, test) {
      this.items = this.items.map((item) => {
        if (item.test_id === test.test_id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
        }
        return item;
      });
      console.log();
      
            this.toasts[test.test_id] =  this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info',duration: null,id: test.id.toString()})
            

      this.downloadTestPaper(url)
        .then((res) => {
          console.log(res);
          this.requestIds.push(res.request_id);
          this.updateRouteDetails({
            type: "requestIds",
            data: { requestIds: this.requestIds },
          });
          
          this.items = this.items.map((item) => {
            if (item.test_id === test.test_id) {
              item.request_id = res.request_id;
            }
            return item;
          });
          this.checkDownloadUpdate();
          // this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info'})

          // this.requestGetTestList()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkDownloadUpdate() {
      console.log(this.requestIds, "request_ids");
		if (this.testStatusTimeout) {
			clearInterval(this.testStatusTimeout);
		  	this.testStatusTimeout = null;
		}
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [constants.DOWNLOAD_TYPES.PRACTICE_REPORT],
      };
      this.getDownloadStatus(reqData)
        .then(async (res) => {
          const arr = [];
          
          // Map over items to update their status and collect data for download
          this.items = this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;

              if (item.url) {
                arr.push({
                  url: data.url,
                  request_id: data.request_id,
                });
              }

              // Remove processed request IDs
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );

              // Update route details
              this.updateRouteDetails({
                type: "requestIds",
                data: { requestIds: this.requestIds },
              });

              // Remove toast notifications
              if (this.toasts[item.test_id]) {
                this.toasts[item.test_id].goAway(0);
              }
              if (this.toasts[item.id]) {
                delete this.toasts[item.id];
              }

              // Show success toast
              this.$toasted.success(
                `Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,
                { icon: "info" }
              );
            }
            return item;
          });

          // Sequentially download files with a delay
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item); // Download the file

            // Add a delay of 1 second
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve();
              }, 1000);
            });
          }

          // Clear the interval if there are no remaining request IDs
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
          .catch((err) => {});
    },
    downloadTestURL(item) {
      console.log(item);

      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };

        item.status = null;
        item.request_id = null;
        item.url = null;
        setTimeout(() => {
          this.deleteDownloadData(reqData)
            .then((res) => {
            })
            .catch((err) => {});
        }, 5000);
      }
    },
    initStudentData() {
      this.isParent = true;
      this.students = this.user.students.map((student) => {
        let studentObj = {
          text: student.name,
          value: {
            id: student.id,
            batchId: student.batch_id,
            type: student.type,
          },
        };
        return studentObj;
      });
      this.selectedStudent = this.students[0].value;
      this.studentId = this.selectedStudent.id;
      this.batchId = this.selectedStudent.batchId;
      this.checkSessionData();
    },

    checkStudentUpgraded() {
      if(this.user.institute === constants.ONLINE_INSTITUTE_ID){
        return false;
      }
      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      if(this.user.institute !== constants.ONLINE_INSTITUTE_ID){
        const boostUpModule = modules.find(m => m.module_id === 10);
        if(boostUpModule){
          return false;
        }
      }
      this.status = this.checkStudentUpgradedHelper(
        this.user.subscription_details
      );
      if (this.status) {
        showUpgradeModal(this);
      }
      
      return this.status;
    },
  },
  beforeDestroy() {
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  },
};
</script>
